import { useState } from 'react';
import { Filters } from './components/FiltersLayout';
import { Map } from './components/Map';
import { Target } from './icons/Target';
import { TargetDisable } from './icons/TargetDisable';

import './styles.scss';

const isDesktop = window.innerWidth > 578;

const LienKetVungPage = () => {
  const [currentType, setCurrentType] = useState('tien-ich');
  const [currentAmenitiesFilters, setCurrentAmenitiesFilters] = useState([]);
  const [currentTrafficFilters, setCurrentTrafficFilters] = useState([]);
  const [showDistanceCircles, setShowDistanceCircles] = useState(true);

  const handleChangeType = (type) => {
    setCurrentType(type);
    // setCurrentFilters([]);
  };

  const handleChangeFilters = (filter, cb) => {
    cb((prev) => {
      if (prev.includes(filter)) {
        return prev.filter((item) => item !== filter);
      }
      if (!filter) {
        return [];
      }

      return [...prev, filter];
    });
  };

  return (
    <div className="vi-tri-page">
      <div className="vi-tri-content">
        <Map
          currentType={currentType}
          currentAmenitiesFilters={currentAmenitiesFilters}
          currentTrafficFilters={currentTrafficFilters}
          showDistanceCircles={showDistanceCircles}
        />
        {isDesktop && (
          <button
            className="distance-circles-toggle"
            onClick={() => setShowDistanceCircles(!showDistanceCircles)}
            title={
              showDistanceCircles
                ? 'Hide distance circles'
                : 'Show distance circles'
            }
          >
            {showDistanceCircles ? (
              <Target color="#f0b619" size={24} />
            ) : (
              <TargetDisable color="#f0b619" size={24} />
            )}
          </button>
        )}
      </div>
      <Filters
        currentAmenitiesFilters={currentAmenitiesFilters}
        currentTrafficFilters={currentTrafficFilters}
        currentType={currentType}
        onChangeType={handleChangeType}
        onChangeAmenitiesFilters={(filter) =>
          handleChangeFilters(filter, setCurrentAmenitiesFilters)
        }
        onChangeTrafficFilters={(filter) =>
          handleChangeFilters(filter, setCurrentTrafficFilters)
        }
      />
    </div>
  );
};

export default LienKetVungPage;
